var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    fill: "white",
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.95 26C22.8667 26 20.8083 25.5458 18.775 24.6375C16.7417 23.7292 14.8917 22.4417 13.225 20.775C11.5583 19.1083 10.2708 17.2583 9.3625 15.225C8.45417 13.1917 8 11.1333 8 9.05C8 8.75 8.1 8.5 8.3 8.3C8.5 8.1 8.75 8 9.05 8H13.1C13.3333 8 13.5417 8.07917 13.725 8.2375C13.9083 8.39583 14.0167 8.58333 14.05 8.8L14.7 12.3C14.7333 12.5667 14.725 12.7917 14.675 12.975C14.625 13.1583 14.5333 13.3167 14.4 13.45L11.975 15.9C12.3083 16.5167 12.7042 17.1125 13.1625 17.6875C13.6208 18.2625 14.125 18.8167 14.675 19.35C15.1917 19.8667 15.7333 20.3458 16.3 20.7875C16.8667 21.2292 17.4667 21.6333 18.1 22L20.45 19.65C20.6 19.5 20.7958 19.3875 21.0375 19.3125C21.2792 19.2375 21.5167 19.2167 21.75 19.25L25.2 19.95C25.4333 20.0167 25.625 20.1375 25.775 20.3125C25.925 20.4875 26 20.6833 26 20.9V24.95C26 25.25 25.9 25.5 25.7 25.7C25.5 25.9 25.25 26 24.95 26ZM11.025 14L12.675 12.35L12.25 10H10.025C10.1083 10.6833 10.225 11.3583 10.375 12.025C10.525 12.6917 10.7417 13.35 11.025 14ZM19.975 22.95C20.625 23.2333 21.2875 23.4583 21.9625 23.625C22.6375 23.7917 23.3167 23.9 24 23.95V21.75L21.65 21.275L19.975 22.95Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.12f23c43d819919d792f8a0d52beacd9.svg";
export { ForwardRef as ReactComponent };